const YOUTUBE_HOSTS = new Set(['youtube.com', 'www.youtube.com', 'm.youtube.com', 'youtu.be', 'www.youtu.be', 'youtube-nocookie.com', 'www.youtube-nocookie.com']);
const VIDEO_ID = /^[\w-]{11}$/;

function urlOf(value) {
  try {
    const text = String(value || '').trim();
    const url = new URL(text.includes('://') ? text : `https://${text}`);
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password && !url.port ? url : null;
  } catch { return null; }
}

export function twitchChannel(value) {
  const text = String(value || '').trim().replace(/^@/, '');
  if (/^[\w]{3,25}$/.test(text)) return text.toLowerCase();
  const url = urlOf(text);
  const name = url?.pathname.replace(/^\/+|\/+$/g, '') || '';
  return url && ['twitch.tv', 'www.twitch.tv', 'm.twitch.tv'].includes(url.hostname) && /^[\w]{3,25}$/.test(name) ? name.toLowerCase() : '';
}

export function youtubeVideoId(value) {
  const url = urlOf(value);
  if (!url || !YOUTUBE_HOSTS.has(url.hostname)) return '';
  const parts = url.pathname.replace(/^\/+|\/+$/g, '').split('/');
  const id = url.hostname.endsWith('youtu.be') ? parts[0] : parts[0] === 'watch' ? url.searchParams.get('v')
    : parts.length === 2 && ['live', 'embed', 'shorts'].includes(parts[0]) ? parts[1] : '';
  return VIDEO_ID.test(id || '') ? id : '';
}

export function youtubeLink(value) {
  const id = youtubeVideoId(value);
  if (id) return `https://www.youtube.com/watch?v=${id}`;
  const url = urlOf(value);
  return url && ['youtube.com', 'www.youtube.com', 'm.youtube.com'].includes(url.hostname)
    && (/^\/@[\w.-]+\/?$/.test(url.pathname) || /^\/channel\/UC[\w-]{22}\/?$/.test(url.pathname))
    ? `https://www.youtube.com${url.pathname.replace(/\/$/, '')}` : '';
}

export function streamSources(live, hostname, origin) {
  const channel = twitchChannel(live.twitchChannel);
  const video = youtubeVideoId(live.youtubeLiveUrl);
  return [
    { id: 'twitch', name: 'Twitch', source: channel, url: channel ? `https://www.twitch.tv/${channel}` : '',
      embed: channel ? `https://player.twitch.tv/?${new URLSearchParams({ channel, parent: hostname, autoplay: 'false', muted: 'true' })}` : '' },
    { id: 'youtube', name: 'YouTube', source: video,
      url: video ? `https://www.youtube.com/watch?v=${video}` : youtubeLink(live.youtube),
      embed: video ? `https://www.youtube.com/embed/${video}?${new URLSearchParams({ autoplay: '0', playsinline: '1', rel: '0', origin })}` : '' },
  ];
}
